import { Container } from "pixi.js";
import { LobbySpineResourcePackage } from "../resources/LobbySpineResourcePackage";
import { ISkeletonData, Spine } from "pixi-spine";
import { PromiseCompletionSource } from "async/PromiseCompletionSource";
import { FadeScreen } from "./FadeScreen";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";

export class CityAnimationContainer extends Container {
    private readonly cityAnimation: Spine;
    private readonly fadeScreen: FadeScreen;

    public constructor(lobbySpineResources: LobbySpineResourcePackage, canvasScaler: ICanvasScaler) {
        super();
        this.cityAnimation = new Spine((lobbySpineResources.assets_views_lobby_spine_animation_Lobby_json as any).spineData as ISkeletonData);
        this.cityAnimation.state.setAnimation(0, "Lobby_near_animation", true);

        this.fadeScreen = new FadeScreen(0.5, 0, 0.85, canvasScaler.referenceWidth, canvasScaler.referenceHeight);
        this.fadeScreen.position.set(-canvasScaler.referenceWidth * 0.5, -canvasScaler.referenceHeight * 0.5 + 33);

        this.addChild(this.fadeScreen, this.cityAnimation);
    }

    private async playSequence(forward: boolean): Promise<void> {
        this.cityAnimation.state.setAnimation(0, forward ? 'Lobby_transfer' : 'Lobby_revers_transfer', false);
        const animationPCS = new PromiseCompletionSource<void>();
        this.cityAnimation.state.addListener({ complete: () => { animationPCS.complete() } })
        await animationPCS.result;
        this.cityAnimation.state.clearListeners();
        this.cityAnimation.state.setAnimation(0, forward ? 'Lobby_near_animation' : 'Lobby_animation', true);
    }

    public async playForward(): Promise<void> {
        this.fadeScreen.fadeIn();
        await this.playSequence(true);
    }

    public async playBackward(): Promise<void> {
        this.fadeScreen.fadeOut();
        await this.playSequence(false);
    }
}